import React, { forwardRef } from "react";
import StaticHeader from "../layout/header/StaticHeader";
import { PageProps, PageRef, StyledPage } from "../formatting/Page";
import { PageFooter } from "../formatting/PageFooter";
import styled from "styled-components";
import { onDesktop } from "@teamscheme/theme";

export interface StaticPageProps extends PageProps {
  greenHeader?: boolean;
  greenBackground?: boolean;
}

export const GreenStaticHeader = styled(StaticHeader)`
  background: ${({ theme }) => theme.nafColor.primary.dew};
`;

export const GreenStyledPage = styled(StyledPage)`
  background: ${({ theme }) => theme.nafColor.primary.dew};
`;

export const AboutContent = styled.div`
  max-width: 40em;
  ${({ theme }) => onDesktop`
    padding: ${theme.spacing.space24} ${theme.spacing.space48};
  `}
`;

const StaticPage = forwardRef<PageRef | null, StaticPageProps>(
  (
    {
      children,
      greenHeader = false,
      greenBackground = false,
      footer = false,
      ...rest
    },
    ref
  ) => {
    return (
      <>
        {greenHeader ? <GreenStaticHeader /> : <StaticHeader />}
        {greenBackground ? (
          <GreenStyledPage ref={ref} {...rest}>
            {children}
          </GreenStyledPage>
        ) : (
          <StyledPage ref={ref} {...rest}>
            {children}
          </StyledPage>
        )}
        {footer ? <PageFooter /> : null}
      </>
    );
  }
);
export default StaticPage;
